import * as styles from './index.module.scss';

import { useContext } from 'react';
import { useRouter } from 'next/router';

import { cleanHeadline, formatPhoneNumber, swapPhone } from '@/helpers/helpers';
import { SiteContext } from '@/contexts/site-context';
import { QueryParamElement } from '@/components/QueryParamElement';

const defaultHeadline = 'Get Home Repair Help Fast!';
const defaultSubheadline = 'Get connected to a local pro right when you need one.';

const ArticleCTA = (props) => {
  const [site] = useContext(SiteContext);
  const headline = props.category?.headline || defaultHeadline;
  const subheadline = cleanHeadline(swapPhone(props.category?.subheadline || defaultSubheadline, site.phone_number));

  const router = useRouter();

  const handleClick = () => {
    router.push(`/${props.category.use_custom_question_flow ? '/cf' : '/flow'}/${props.category.url_slug}`);
  };

  return (
    <div className={styles['hero-category-container']}>
      <div className={`${styles['container']} container`}>
        <QueryParamElement element="h1" queryParam="h1" fallbackText={headline} />
        <div className={styles['wrapper']}>
          <div className={styles['wrapper-flex-container']}>
            <QueryParamElement element="h2" queryParam="h2" fallbackText={subheadline} injectFallback />
          </div>
          <div className={styles['wrapper-flex-container']}>
            <div className={styles['category-trigger-container']}>
              <div className="button" onClick={() => handleClick()}>
                Get Help Today
              </div>
            </div>
            {props.category?.showPhoneNumber && (
              <div className={styles['phone-trigger']}>
                Call 24/7 at
                <a href={`tel:${site.phone_number}`}>{formatPhoneNumber(site.phone_number)}</a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticleCTA;
